import { Box, CircularProgress, Typography } from "@mui/material";
import { MODAL_CREATE_WITH_IA_GENERATING } from "../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../lib/i18next";

const getAspectRatioCss = (aspectRatio) =>
  aspectRatio ? String(aspectRatio).replace(":", "/") : "1";

const GenerationPlaceholderCard = ({ data = {} }) => {
  const { t } = useTranslationApp();

  return (
    <Box
      data-testid="generation-placeholder-card"
      sx={{
        position: "relative",
        aspectRatio: getAspectRatioCss(data.aspectRatio),
        bgcolor: "grey.100",
        borderRadius: 2,
        border: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <CircularProgress size={32} />
        <Typography variant="body2" color="text.secondary">
          {t(MODAL_CREATE_WITH_IA_GENERATING)}
        </Typography>
      </Box>
    </Box>
  );
};

export default GenerationPlaceholderCard;
